const trimString = v => {
  if (typeof v === 'string') {
    return v.trim()
  }
}
export default {
  install: function(Vue) {
    Vue.prototype.trimString = v => trimString(v)
  }
}
